import { Button, Divider } from '@mui/material';
import TicketPreview from './TicketPreview';
import TicketNumberInput from '../FormFields/TicketNumberInput';
import { H6, Body2, Body3 } from '../../themes/typography';
import { useTicketData } from '../../context/ticketDataContext';

export default function TicketListingPreview({ previewData }) {
    const { ticketData } = useTicketData();
    return (
        <div className="ticket-listing-preview-container">
            <div className="ticket-listing-preview">
                {previewData?.tickets?.map((ticket, index) => (
                    <TicketPreview
                        key={index}
                        ticketId={ticket.ticket_id}
                        ticketName={ticket.ticket_name}
                        ticketDescription={ticket.description}
                        originalPrice={ticket?.price}
                        ticketValidDates={ticket?.ticketValidFor?.event_schedule}
                        ticketQuantitySelector={
                            <TicketNumberInput
                                minQuantity={0}
                                maxQuantity={10}
                                ticketId={1}
                                ticketName={ticket.ticket_name}
                                ticketQuantity={10}
                                ticketDiscountedPrice={100}
                                ticketOriginalPrice={100}
                                ticketDiscountRate={0}
                                ticketSold={0}
                                exceedQtyStatus={false}
                                ticketDescription={'This is a preview ticket for the event.'}
                            />
                        }
                    />
                ))}
            </div>
            <div className="add-to-cart-preview-details">
                <TicketAddToCart ticketData={ticketData} />
                <Button variant="main" disabled>
                    Proceed
                </Button>
            </div>
        </div>
    );
}

function TicketAddToCart({ ticketData }) {
    console.log(ticketData);
    return (
        <div className="preview-event-add-to-cart">
            <H6 color="var(--secondary-color)">Cart Details</H6>

            <div className="preview-ticket-cart-summary">
                <div className="preview-ticket-name-and-qty-label-section">
                    <div>
                        <Body2>Description</Body2>
                    </div>

                    <div>
                        <Body2>Quantity</Body2>
                    </div>
                </div>

                <Divider sx={{ borderColor: 'var(--divider-color)', alignSelf: 'stretch' }} />

                <div className="preview-ticket-listing-container">
                    {ticketData.tickets.map((ticket, index) => {
                        return (
                            <div className="preview-tickets-cart-listing-section" key={index}>
                                <div className="preview-ticket-name-container">
                                    <Body3 fontWeight={500}>{ticket.ticketName}</Body3>
                                </div>

                                <div className="preview-ticket-quantity-container">
                                    <Body3 color="var(--secondary-color)" fontWeight={500}>
                                        {ticket.quantity}
                                    </Body3>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>

            <Divider sx={{ borderColor: 'var(--divider-color)', alignSelf: 'stretch' }} />

            <div className="preview-ticket-cart-total-qty-section">
                <H6>Total Tickets :</H6>
                <H6 color="var(--secondary-color)">{ticketData.totalTickets}</H6>
            </div>
        </div>
    );
}

const ticketData = {
    tickets: [
        {
            ticketName: 'VIP Ticket',
            quantity: 2
        },
        {
            ticketName: 'Regular Ticket',
            quantity: 5
        }
    ],
    totalTickets: 7
};
